import isNil from 'lodash/isNil';

import type { AppData } from '../../../types/app_data';
import type { Step } from '../../types/step';
import { parseExtractName } from '../../../utils/name';
import { AppStepSection, StepCategory } from '../../../types/app_data';

export const MiddleNameStep: Step = {
  id: 'middlename',
  pathname: '/middlename',
  canShow: (appData: AppData) => {
    const parsedName = parseExtractName(appData.name);
    if (appData.stepSection === AppStepSection.CreateAccount) {
      // Show if no prefilling page was shown, and if entered name length is >3
      return !appData.featureData?.askPhoneNamePrefilled && parsedName.parts.length >= 3;
    }
    if (parsedName.parts.length >= 3 && !appData.signupParams?.nameVariation) {
      return true;
    }
    return false;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => !isNil(appData.nameVariationManualEntry),
  category: () => StepCategory.GarageOnlyAccount,
};
